import React, { useState, useEffect } from "react";
import Sidebar from "../Sidebar/Sidebar";
import api from "../../api";
import "./PharmacyVerificationForm.css";

const PharmacyVerificationForm = () => {
  const [licenseNumber, setLicenseNumber] = useState("");
  const [cacNumber, setCacNumber] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    setLoading(true);

    try {
      const response = await api.post("/users/pharmacies/verify", {
        yearly_practicing_license_number: licenseNumber.trim(),
        cac_number: cacNumber.trim(),
      });

      setSuccess(response.data.message || "Verification request submitted.");
      setLicenseNumber("");
      setCacNumber("");
    } catch (err) {
      console.error("Verification request error:", err);

      let msg = err?.response?.data?.detail || err?.response?.data?.message || "Submission failed. Please try again.";

      // Handle array of validation errors (FastAPI Pydantic validation)
      if (Array.isArray(msg)) {
        msg = msg.map((e) => e.msg || JSON.stringify(e)).join(", ");
      }

      // Handle object error
      if (typeof msg === "object") {
        msg = JSON.stringify(msg, null, 2);
      }

      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="verification-page-container">
      {!isMobile && <Sidebar />}

      <div className="verification-content">
        <h2 className="verification-title">🏥 Pharmacy Verification</h2>

        <div className="verify-form-container">
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="license">Annual Practicing License Number</label>
              <input
                id="license"
                type="text"
                placeholder="Enter Yearly Practicing License Number"
                value={licenseNumber}
                onChange={(e) => setLicenseNumber(e.target.value)}
                disabled={loading}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="cac">CAC Number</label>
              <input
                id="cac"
                type="text"
                placeholder="Enter CAC Number"
                value={cacNumber}
                onChange={(e) => setCacNumber(e.target.value)}
                disabled={loading}
                required
              />
            </div>

            <button type="submit" disabled={loading}>
              {loading ? "Submitting..." : "Submit Verification"}
            </button>
          </form>

          {error && <div className="error-message" style={{ whiteSpace: "pre-wrap" }}>{error}</div>}
          {success && <div className="success-message">{success}</div>}
        </div>
      </div>
    </div>
  );
};

export default PharmacyVerificationForm;